import { inject, Injectable } from "@angular/core";
import { CommunicationService } from "../http/communication.service";
import { Observable, catchError, timeout } from "rxjs";
import { AlertSubscriptionsListResponse, AlertSubscriptionPayload, AlertSubscriptionResponse, GetAlertSubscriptionResponse } from "../components/alert-center/types";
import { Permissions } from '../shared/permissions';
import { AuthorizationService } from "./authorization.service";

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
    private timeoutDuration = 30000;
    private communicationService = inject(CommunicationService);
    private authorizationService = inject(AuthorizationService);

    public hasPermissions(): boolean {
        return this.authorizationService.hasPermissions([
            Permissions.READ_POLARIS_ALERTS,
            Permissions.WRITE_POLARIS_ALERTS
        ]);
    }

    public getAlertSubscriptions(accountId: string): Observable<AlertSubscriptionsListResponse> {
        return this.communicationService.httpGet<AlertSubscriptionsListResponse>(`/polaris/alerts/home/?accountId=${accountId}`)
        .pipe(
            timeout(this.timeoutDuration),
            catchError((error) => {
                console.error('Error fetching alert subscriptions', error);
                throw error;
            }
        ));
    }

    public createAlertSubscription(payload: AlertSubscriptionPayload): Observable<AlertSubscriptionResponse> {
        return this.communicationService.httpPost<AlertSubscriptionResponse>(`/polaris/alerts/subscription`, payload)
        .pipe(
            timeout(this.timeoutDuration),
            catchError((error) => {
                console.error('Error creating alert subscription', error);
                throw error;
            }
        ));
    }

    public updateAlertSubscription(payload: AlertSubscriptionPayload): Observable<AlertSubscriptionResponse> {
        return this.communicationService.httpPut<AlertSubscriptionResponse>(`/polaris/alerts/subscription`, payload)
        .pipe(
            timeout(this.timeoutDuration),
            catchError((error) => {
                console.error('Error creating alert subscription', error);
                throw error;
            }
        ));
    }

    public getAlertSubscription(alertId: string): Observable<GetAlertSubscriptionResponse> {
        return this.communicationService.httpGet<GetAlertSubscriptionResponse>(`/polaris/alerts/${alertId}`)
        .pipe(
            timeout(this.timeoutDuration),
            catchError((error) => {
                console.error('Error fetching alert subscription', error);
                throw error;
            }
        ));
    }

}